import { render, staticRenderFns } from "./moreSpec.vue?vue&type=template&id=18ca5461&scoped=true&"
import script from "./moreSpec.vue?vue&type=script&lang=js&"
export * from "./moreSpec.vue?vue&type=script&lang=js&"
import style0 from "./moreSpec.vue?vue&type=style&index=0&id=18ca5461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ca5461",
  null
  
)

export default component.exports